import {
	Container,
	ContainerPadding,
	styled,
	Text,
	TextAlignment,
	TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import { Checkmark } from '@volkswagen-onehub/icons-core';
import React from 'react';

const IconStyled = styled.div`
	color: white;
	width: 64px;
	height: 64px;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 50%;
	background-color: #001e50;
`;

const StyledContainer = styled(Container)`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
`;

export const GTIDayParticipado: React.FC = () => {
	return (
		<Container
			padding={{
				right: ContainerPadding.dynamic0100,
				bottom: ContainerPadding.dynamic0100,
				left: ContainerPadding.dynamic0100,
			}}
			horizontalAlign={'center'}
			wrap={'always'}
		>
			<StyledContainer wrap={'always'} stretchContent>
				<IconStyled>
					<Checkmark />
				</IconStyled>
			</StyledContainer>

			<Container
				wrap={'always'}
				padding={{
					top: ContainerPadding.dynamic0100,
				}}
			>
				<Text appearance={TokenTextAppearance.headline300} textAlign={TextAlignment.center}>
					<Text bold>¡Recibido!</Text>
				</Text>

				<Container
					wrap={'always'}
					padding={{
						top: ContainerPadding.dynamic0100,
						bottom: ContainerPadding.dynamic0100,
					}}
					verticalAlign={'center'}
					horizontalAlign={'center'}
				>
					<Text appearance={TokenTextAppearance.copy200} textAlign={TextAlignment.center}>
						Muy pronto contactaremos contigo para hacerte llegar las entradas al GTI 50 Fest.
						<br />
						<Text bold>Gracias por formar parte de nuestra historia.</Text>
					</Text>
				</Container>
			</Container>
		</Container>
	);
};
